import React from "react";

export default function Footer() {
  return (
    <footer class="footer-copy">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <p>2024 &copy; Website Designed by R & H</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
